import { FunctionComponent } from 'react';

import AcceptTermsInput from 'components/AcceptTermsInput';
import CardBodyText from 'components/CardBodyText';

import useSatNoteFormTerms from './useSatNoteFormTerms';

const SatNoteFormTerms: FunctionComponent = () => {
  const { isLoading, copy } = useSatNoteFormTerms();
  return (
    <>
      <div className="font-bold text-14-22-em text-neutral-700 mb-6">
        Read and agree to the terms below
      </div>
      {copy.body.map((copyLine: string) => (
        <CardBodyText key={copyLine} isLoading={isLoading}>
          {copyLine}
        </CardBodyText>
      ))}
      <div className="mt-6 mb-2">
        <AcceptTermsInput
          isLoading={isLoading}
          label={copy.button}
          showLinkLabel={false}
        />
      </div>
    </>
  );
};

export default SatNoteFormTerms;
